import { inject } from '@angular/core';
import {
  HttpInterceptorFn,
  HttpRequest,
  HttpHandlerFn,
  HttpEvent,
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { AuthService } from '../services/auth.service';
import { environment } from '../../environments/environment';

const API_URL = environment.apiUrl;

export const TokenInterceptor: HttpInterceptorFn = (
  request: HttpRequest<unknown>,
  next: HttpHandlerFn
): Observable<HttpEvent<unknown>> => {
  const authService = inject(AuthService);
  const user = authService.token$.value;

  // Append API URL unless static file
  if (!request.url.endsWith('.json') && !request.url.endsWith('.pdf')) {
    request = request.clone({ url: API_URL + request.url });
  }

  if (
    !user ||
    request.url.includes('/auth/login') ||
    request.url.includes('/auth/logout')
  ) {
    return next(request);
  }

  request = authService.addAuthHeader(request, user);

  return next(request).pipe(
    map((response) => response),
    catchError((error) => {
      if (!request.url.includes('/auth/logout') && error.status === 401) {
        authService.logout();
      }
      return throwError(() => error);
    })
  );
};
